import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, isRef as _isRef, createTextVNode as _createTextVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ec39ccec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "order-search flex-col" }
const _hoisted_2 = {
  key: 0,
  class: "flex order-status"
}
const _hoisted_3 = { class: "order-table" }
const _hoisted_4 = { key: 1 }

import { ElMessageBox, ElMessage } from 'element-plus'
import { t } from '@/plugins/i18n'
import { ref, reactive, toRaw, computed, nextTick, onMounted, watch } from 'vue'
import { useStore } from 'vuex'
import STable from '@/components/Table/index.vue'
import AppLink from '@/components/common/AppLink.vue'
import ShoppingPreview from '@/components/common/ShoppingPreview.vue'
import { pageAbnormalOrder, batchQueryCombinationProduct, getPlatformOrderDetail, getB2bPlatformOrderDetail } from '@/apis/order'
import { getCartAmount } from '@/apis/shopcart'
import { batchAddProduct, getProductList } from '@/apis/stock'
import type { FormInstance } from 'element-plus'
import { getJapanTime, setStartDateTime, setEndDateTime } from '@/util/common'
import ProductSku from '../components/ProductSku.vue'
import QuestionReason from './QuestionReason.vue'
import { setAdt } from '@/util/calcAdt'
import {
  applyCancelColumns1,
  applyCancelColumns2,
  applyCancelTableConfig,
  cancelProgressDict,
  cancelProgressOption
} from './data'
import { setProdcutLink } from '../data'
import { useRtfix, isD2C, useSite } from '@/store'
import { useRoute, useRouter } from 'vue-router'
import { QuestionFilled } from '@element-plus/icons-vue'
import ADialog from './ADialog.vue'
import dblclick from '@/components/BatchSearch/index'
import BatchSearch from '@/components/BatchSearch/index.vue'
import bus from '@/util/useBus'
import { showCurrentUnit } from '@/util/useYan'
import { COUNTRY } from '@/global'
import { getAreaList, getTotalCountryList } from '@/util/useCountry'


export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {

const route = useRoute()
const router = useRouter()

const store = useStore()
const form = reactive({
  processManner: '1',
  abnormalOrderType: 3,
  productSku: '',
  platformOrderNo: '',
  cancelApplyStartTime: '',
  cancelApplyEndTime: '',
  cancelProgress: '',
  customerOrderNo: ''
})

const ProblemVisible = ref(false)
const rowItem = ref({})

form.processManner = isD2C() ? '1' : '0'
// 消息
if (route.query.platformOrderNo2) {
  form.platformOrderNo = route.query.platformOrderNo2
}
// if (route.query.productSku) {
//   form.productSku = route.query.productSku
// }
if (route.query.processManner) {
  form.processManner = route.query.processManner
}
const searchDate = computed({
  get: () => [form.cancelApplyStartTime, form.cancelApplyEndTime],
  set: (newVal) => { [form.cancelApplyStartTime, form.cancelApplyEndTime] = newVal ?? [] }
})

const changeTab = (type: string) => {
  form.processManner = type
  pageData.value = {
    page: 1,
    limit: 30
  }
  nextTick(() => {
    STableRef.value && STableRef.value.getData()
  })
}
const formRef = ref<FormInstance>()

const pageData = ref({
  page: 1,
  limit: 30
})

const filterData = computed(() => {
  return {
    ...form,
    cancelApplyStartTime: setStartDateTime(form.cancelApplyStartTime),
    cancelApplyEndTime: setEndDateTime(form.cancelApplyEndTime)
  }
})

const resetForm = (formEl: FormInstance | undefined) => {
  if (!formEl) return
  isBatchSearch.value = false
  form.cancelApplyStartTime = ''
  form.cancelApplyEndTime = ''
  form.platformOrderNo = ''
  form.productSku = ''
  form.customerOrderNo = ''
  // formEl.resetFields()
  refreshTable(true)
}

const STableRef = ref()
const refreshTable = (type?: boolean) => {
  if (type) {
    pageData.value = {
      page: 1,
      limit: 30
    }
  }
  nextTick(() => {
    STableRef.value && STableRef.value.getData()
  })
}

expose({
  refreshTable
})

const queryCancelOrder = async () => {
  // 取消订单跳转的一次性查询
  const productSkuList = sessionStorage.getItem('productSkuList')
  const platformOrderNoList = sessionStorage.getItem('platformOrderNoList')
  if (productSkuList?.length && platformOrderNoList?.length) {
    form.processManner = '0'
    const SkuList = productSkuList?.split(',') ?? []
    const OrderNoList = platformOrderNoList?.split(',') ?? []
    bus.emit('batchSearchApplyCancel', { productSkuList: SkuList, platformOrderNoList: OrderNoList })
    sessionStorage.removeItem('productSkuList')
    sessionStorage.removeItem('platformOrderNoList')
  }
}

watch(() => route.query.t, queryCancelOrder)

onMounted(() => {
  queryCancelOrder()
})

const batchSearchParams = ref({})
const isBatchSearch = ref(false) // 是否批量搜索
bus.on('batchSearchApplyCancel', (params: any) => {
  isBatchSearch.value = true
  batchSearchParams.value = {
    ...params,
    abnormalOrderType: 3,
    processManner: form.processManner
  }
  refreshTable(true)
})
const search = () => {
  isBatchSearch.value = false
  refreshTable(true)
}
const addcart = async (e:any) => {
  e.productAddLoading = true
  // 查询订单信息详情
  const api = isD2C() ? getPlatformOrderDetail : getB2bPlatformOrderDetail
  const { data } = await api({
    platformOrderId: e.platformOrderId
  })
  let productInfo:any = null
  data.platformOrderItemList.forEach((item:any) => {
    if (productInfo) return
    if (item.productSku === e.productSku) {
      productInfo = item
      return
    }
    if (item.productType === 3) {
      item.combinationOrderItemList?.forEach((temp:any) => {
        if (temp.productSku === e.productSku) {
          productInfo = item
        }
      })
    }
  })
  let address:any = null
  if (isD2C() && data.platformOrder?.orderType === 1) {
    const regex = /^\d*$/
    if (regex.test(data.platformOrderDeliverAddressDTO?.province)) {
      // 正常订单直接取
      address = {
        ...data.platformOrderDeliverAddressDTO
      }
    } else {
      // api地址信息为中文时需要匹配匹配不到则回显空
      address = await changeAddressId({
        ...data.platformOrderDeliverAddressDTO
      })
    }
  }
  // 商品类型: 1-普通商品; 2-OEM商品; 3-组合商品
  try {
    let list: any = []
    if (e.productType === 1) {
      const cartAdditionList: any = await setAdt(e.productCategoryFrontendNdId, 'cartAdditionList', 'noAdditionalFlag', [], undefined, e.goodsCountry === COUNTRY.KR)
      list = [
        {
          productType: e.productType,
          productSku: e.productSku,
          orderQuantity: e.cancelQuantity,
          ...cartAdditionList
        }
      ]
    } else if (e.productType === 2) {
      // oem商品信息没有报价信息 先去库存查询一遍获取最新报价单信息
      if (!productInfo.searchSourcePriceId || productInfo.searchSourcePriceId === '-') {
        const stockResult = await getProductList({
          pageNum: 1,
          pageSize: 10,
          productSkuOrName: e.productSku
        })
        productInfo.searchSourcePriceId = stockResult.data?.records?.[0].searchSourcePriceId ?? ''
        productInfo.searchSourceOrderId = stockResult.data?.records?.[0].searchSourceOrderId ?? ''
        productInfo.searchSourceOrderNo = stockResult.data?.records?.[0].searchSourceOrderNo ?? ''
      }
      if (!productInfo.searchSourcePriceId || productInfo.searchSourcePriceId === '-') {
        ElMessage.warning(t('系统异常'))
        return
      }
      list = [
        {
          productType: e.productType,
          productSku: e.productSku,
          orderQuantity: e.cancelQuantity,
          oemOrderType: productInfo.searchSourceOrderRepurchaseApplyId && productInfo.searchSourceOrderRepurchaseApplyId !== '-' ? 4 : 2,
          searchSourceOrderCode: productInfo.searchSourceOrderNo,
          searchSourceOrderId: productInfo.searchSourceOrderId,
          searchSourceSupplierPriceId: productInfo.searchSourcePriceId
        }
      ]
    } else if (e.productType === 3) {
      let combinationProductAdt = await batchQueryCombinationProduct({ combinationProductSkus: [e.productSku], withSubProduct: 1 })
      if (combinationProductAdt.code === '0') {
        combinationProductAdt = combinationProductAdt.data[0].combinationProductItems
      } else {
        return
      }
      const combinationProductItemAddCartList = await Promise.all(
        combinationProductAdt.map(async (item: any) => {
          const combinationProductAdtItemCache = combinationProductAdt.filter((y: any) => y.shopProductSku === item.shopProductSku)[0]
          const cartAdditionList: any = await setAdt(item.productCategoryFrontendNdId, 'combinationProductItemAdditionList', 'noAdditionalFlag', combinationProductAdtItemCache?.additionList, combinationProductAdtItemCache?.noAdditionalFlag, item.goodsCountry === COUNTRY.KR)
          return {
            ...cartAdditionList,
            shopProductSku: item.shopProductSku
          }
        })
      )
      list = [
        {
          productType: e.productType,
          productSku: e.productSku,
          orderQuantity: e.cancelQuantity,
          combinationProductItemAddCartList: combinationProductItemAddCartList
        }
      ]
    }
    const { success } = await batchAddProduct(list)
    if (success) {
      refreshTable()
      showAddCartInfo(e.cancelQuantity, address, e.goodsCountry)
    }
    e.productAddLoading = false
  } catch (error) {
    e.productAddLoading = false
  }
}
const showAddCartInfo = async (len: any, address?: any, countryCode?:string) => {
  const amount = await getCartAmount().then((res) => res.data)
  ElMessageBox.confirm(
    `
        <div>${t('X件商品已添加至购物车').replace('X', len)}</div>
        <div>${t('当前购物车共X种商品').replace('X', amount)}</div>
      `,
    t('添加成功'),
    {
      dangerouslyUseHTMLString: true,
      confirmButtonText: t('去结算'),
      cancelButtonText: t('留在此页'),
      type: 'success'
    }
  ).then(() => {
    if (address) {
      const add = store.getters['bussiness/getAddress'] ?? {}
      add[countryCode ?? 'CN'] = address
      store.commit('bussiness/deliverData', add)
    }
    router.push(useRtfix('shopcart', { query: { sc: countryCode ?? 'CN' } }))
  })
}
// api地址存储的是文字需要匹配地址库并返回对应的值
const changeAddressId = async (address:any) => {
  const countryList = await getTotalCountryList()
  // 找到对应国家
  const country = countryList.find((v) => v.intAreaId === address.country) ?? {}
  let province:any = {}
  let city:any = {}
  if (country.intAreaId) {
    // 找对应城市
    const key = country.code === 'JP' ? 'name' : 'nameEn'
    const areaList = await getAreaList(country)
    province = areaList.find((v) => v[key] === address.province) ?? {}
    if (province.intAreaId && province.children?.length > 0) {
      city = province.children?.find((v) => v[key] === address.city) ?? {}
    }
  }
  return {
    ...address,
    province: province?.intAreaId ?? '',
    city: city?.intAreaId ?? '',
    // 个人通关码
    clearanceCode: address.clearanceCode
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_table_button = _resolveComponent("table-button")!
  const _component_member_event_box = _resolveComponent("member-event-box")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_unref(useSite)())
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_unref(isD2C)())
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("p", {
              class: _normalizeClass({ active: _unref(form).processManner === '1' }),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (changeTab('1')))
            }, _toDisplayString(_unref(t)('取消发货任务记录')), 3),
            _createElementVNode("p", {
              style: {"margin-left":"62px"},
              class: _normalizeClass({ active: _unref(form).processManner === '0' }),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (changeTab('0')))
            }, _toDisplayString(_unref(t)('取消采购记录')), 3)
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_el_form, {
        ref: (_value, _refs) => {
          _refs['formRef'] = _value
          formRef.value = _value
        },
        inline: true,
        model: _unref(form)
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: _unref(t)('平台商品SKU'),
            prop: "productSku"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _unref(form).productSku,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(form).productSku) = $event)),
                onDblclick: _cache[3] || (_cache[3] = ($event: any) => {_unref(form).productSku = ''; _unref(dblclick)('productSkuList')}),
                placeholder: _unref(t)('双击批量搜索'),
                style: {"width":"220px"}
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _unref(t)('THE CKB订单编号')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _unref(form).platformOrderNo,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(form).platformOrderNo) = $event)),
                onDblclick: _cache[5] || (_cache[5] = ($event: any) => {_unref(form).platformOrderNo = ''; _unref(dblclick)('platformOrderNoList')}),
                placeholder: _unref(t)('双击批量搜索'),
                style: {"width":"220px"}
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _unref(isD2C)() ? _unref(t)('客户订单编号') : _unref(t)('订单标题')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _unref(form).customerOrderNo,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(form).customerOrderNo) = $event)),
                style: {"width":"190px"},
                class: "w-240"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _unref(t)('申请时间')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_date_picker, {
                modelValue: _unref(searchDate),
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_isRef(searchDate) ? (searchDate).value = $event : null)),
                type: "daterange",
                "range-separator": "-",
                "start-placeholder": _unref(t)('开始时间'),
                "end-placeholder": _unref(t)('结束时间'),
                format: "YYYY-MM-DD",
                "value-format": "YYYY-MM-DD"
              }, null, 8, ["modelValue", "start-placeholder", "end-placeholder"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "warning",
                onClick: search
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('搜索')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                type: "text",
                onClick: _cache[8] || (_cache[8] = ($event: any) => (resetForm(formRef.value)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('重置')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(STable, {
        ref: (_value, _refs) => {
          _refs['STableRef'] = _value
          STableRef.value = _value
        },
        "page-data": pageData.value,
        "onUpdate:page-data": _cache[9] || (_cache[9] = ($event: any) => ((pageData).value = $event)),
        isImmediatelyExec: false,
        api: _unref(pageAbnormalOrder),
        filterData: isBatchSearch.value ? batchSearchParams.value : _unref(filterData),
        columns: _unref(form).processManner === '1' ? _unref(applyCancelColumns1) : _unref(applyCancelColumns2),
        tableConfig: _unref(applyCancelTableConfig)
      }, {
        cancelRefundAmount: _withCtx(({ row }) => [
          _createElementVNode("div", null, _toDisplayString(row.cancelRefundAmount) + " " + _toDisplayString(_unref(showCurrentUnit)(row.goodsCountry === _unref(COUNTRY).KR)), 1)
        ]),
        platformOrderNo: _withCtx(({ row }) => [
          (row.platformOrderId)
            ? (_openBlock(), _createBlock(AppLink, {
                key: 0,
                to: _unref(useRtfix)('OrderInfo', { params: { id: row.platformOrderId } })
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(row.platformOrderNo), 1)
                ]),
                _: 2
              }, 1032, ["to"]))
            : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(row.platformOrderNo), 1))
        ]),
        productSku: _withCtx(({ row }) => [
          row
            ? (_openBlock(), _createBlock(ProductSku, {
                key: 0,
                row: row
              }, null, 8, ["row"]))
            : _createCommentVNode("", true)
        ]),
        productPropertiesName: _withCtx(({ row }) => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((row.productPropertiesName || '').split(';'), (prop) => {
            return (_openBlock(), _createElementBlock("p", { key: prop }, _toDisplayString(prop.replace(/[+-]?\d+:[+-]?\d+:/,
              '')), 1))
          }), 128))
        ]),
        cancelApplyTime: _withCtx(({ row }) => [
          _createTextVNode(_toDisplayString(_unref(getJapanTime)(row.cancelApplyTime)), 1)
        ]),
        shoppingInfo: _withCtx(({ row }) => [
          _createVNode(ShoppingPreview, {
            image: row.productSkuImg || row.productMainImg || '',
            name: row.productTitleJp,
            url: _unref(setProdcutLink)(row)
          }, null, 8, ["image", "name", "url"])
        ]),
        cancelProgress: _withCtx(({ row }) => [
          _createTextVNode(_toDisplayString(_unref(cancelProgressDict)[row.cancelProgress] || '-'), 1)
        ]),
        cancelType: _withCtx(({ row }) => [
          _createTextVNode(_toDisplayString(row.cancelType === 1 ? _unref(t)('客户取消') : row.cancelType === 2 ? _unref(t)('系统取消') : '-'), 1)
        ]),
        productQuestionReason: _withCtx(({ row }) => [
          _createVNode(QuestionReason, {
            item: row,
            type: _unref(form).processManner
          }, null, 8, ["item", "type"])
        ]),
        cancelRefundAmountHead: _withCtx(() => [
          _createElementVNode("div", null, [
            _createTextVNode(_toDisplayString(_unref(t)('结算时应退款金额')) + " ", 1),
            _createVNode(_component_el_tooltip, {
              effect: "dark",
              content: _unref(t)('商品代金，订单结算后解冻至账户余额'),
              placement: "top"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, { style: {"vertical-align":"text-bottom","cursor":"pointer"} }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(QuestionFilled))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["content"])
          ])
        ]),
        handler: _withCtx(({ scope }) => [
          _createVNode(_component_member_event_box, {
            icon: "member_coin",
            "listen-variable": scope.row
          }, {
            default: _withCtx(() => [
              _createVNode(_component_table_button, {
                title: _unref(t)('重新加购'),
                onClick: ($event: any) => (addcart(scope.row)),
                loading: scope.row.productAddLoading
              }, null, 8, ["title", "onClick", "loading"])
            ]),
            _: 2
          }, 1032, ["listen-variable"])
        ]),
        _: 1
      }, 8, ["page-data", "api", "filterData", "columns", "tableConfig"])
    ]),
    _createVNode(ADialog, {
      visible: ProblemVisible.value,
      "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => ((ProblemVisible).value = $event)),
      rowItem: rowItem.value,
      onlyRead: true
    }, null, 8, ["visible", "rowItem"]),
    _createVNode(BatchSearch, { title: "ApplyCancel" })
  ], 2))
}
}

})